export default {"src":"/_next/static/media/up_arrow_icon.c0283542.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};